import { render, staticRenderFns } from "./cprtraining.vue?vue&type=template&id=3294a5be&scoped=true"
import script from "./cprtraining.vue?vue&type=script&lang=js"
export * from "./cprtraining.vue?vue&type=script&lang=js"
import style0 from "./cprtraining.vue?vue&type=style&index=0&id=3294a5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294a5be",
  null
  
)

export default component.exports